import styled from "@mui/styled-engine-sc";
import Breadcrumbs from "@mui/material/Breadcrumbs";

export const StyledBreadcrumbs = styled(Breadcrumbs)`
  ${({ theme }) => `
    padding: 0;

    font-family: ${theme.typography.body2.fontFamily};
    font-size: ${theme.typography.body2.fontSize};
    font-weight: ${theme.typography.body2.fontWeight};
    line-height: ${theme.typography.body2.lineHeight};

    ol {
      display: flex;
      align-items: center;
      gap: ${theme.spacing(2)}; /* 8px */
      padding: 0;
      margin: 0;
    }

    li {
      margin: 0;
    }

    a {
      display: flex;
      align-items: center;
      color: ${theme.palette.gray.neutralGray700};
      text-decoration: none;
    }

    span {
      display: flex;
      align-items: center;
      color: ${theme.palette.secondary.main}; /* #8B1538 */
    }

    .MuiBreadcrumbs-separator {
      margin: 0;
      color: ${theme.palette.gray.neutralGray700};
    }

    /* Mobile specific adjustments if needed later */
    ${theme.breakpoints.down("md")} {
      font-size: ${theme.typography.body2.fontSize};
    }
  `}
`;
